/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import {
  CloudEditResponse, CloudPriceResponse, DashboardState, GetServerResponse,
} from './types';
import { MutationRequestStatus } from '../types';

export const mutations: MutationTree<DashboardState> = {
  gamecloudEditLoading(state) {
    state.error = false;
    state.gamecloudEdit = undefined;
  },
  gamecloudEditLoaded(state, payload: CloudEditResponse) {
    state.error = false;
    state.gamecloudEdit = payload;
  },
  gamecloudEditError(state) {
    state.error = true;
    state.gamecloudEdit = undefined;
  },
  cloudPriceLoading(state: DashboardState) {
    state.cloudPrice = {
      data: undefined,
      error: undefined,
      status: MutationRequestStatus.LOADING,
    };
  },
  cloudPriceLoaded(state: DashboardState, payload: CloudPriceResponse) {
    state.cloudPrice = {
      data: payload,
      error: undefined,
      status: MutationRequestStatus.SUCCESS,
    };
  },
  cloudPriceError(state: DashboardState, payload) {
    state.cloudPrice = {
      data: undefined,
      error: payload,
      status: MutationRequestStatus.ERROR,
    };
  },
  editOrderLoading(state) {
    state.editOrder = {
      data: undefined,
      status: MutationRequestStatus.LOADING,
      error: undefined,
    };
  },
  editOrderLoaded(state) {
    state.editOrder = {
      data: null,
      status: MutationRequestStatus.SUCCESS,
      error: undefined,
    };
  },
  editOrderError(state, payload) {
    state.editOrder = {
      data: null,
      status: MutationRequestStatus.ERROR,
      error: payload,
    };
  },
  getServerLoading(state) {
    state.getServer = {
      data: undefined,
      status: MutationRequestStatus.LOADING,
      error: undefined,
    };
  },
  getServerLoaded(state, payload: GetServerResponse) {
    state.getServer = {
      data: payload,
      status: MutationRequestStatus.SUCCESS,
      error: undefined,
    };
  },
  getServerError(state, payload) {
    state.editOrder = {
      data: null,
      status: MutationRequestStatus.ERROR,
      error: payload,
    };
  },
  updateServerLoading(state) {
    state.updateServer = {
      data: undefined,
      status: MutationRequestStatus.LOADING,
      error: undefined,
    };
  },
  updateServerSuccess(state) {
    state.updateServer = {
      data: undefined,
      status: MutationRequestStatus.SUCCESS,
      error: undefined,
    };
  },
  updateServerError(state, payload) {
    state.updateServer = {
      data: undefined,
      status: MutationRequestStatus.ERROR,
      error: payload,
    };
  },
};
